<template>
  <div class="bp-filter-button-component">
    <button
      class="btn btn-new-secondary fs-16 px-2"
      :class="buttonClass"
      @click="() => (modal = true)"
    >
      <i class="fa-regular fa-filter text-neutral-900 fs-16"></i>
      <span v-if="label" class="ml-3">{{ label }}</span>
    </button>
    <responsive-modal v-model="modal">
      <div class="p-5">
        <div class="d-flex align-items-center justify-content-between">
          <span class="fs-18">
            Filtrar
          </span>
          <button class="btn btn-sm btn-square" @click="close">
            <i class="icon-x fs-20 text-secondary" />
          </button>
        </div>
        <span class="fs-14" style="color: #77788EDD;" v-if="description">
          Selecione os filtros e clique em aplicar
        </span>
        <div class="mb-6"></div>
        <slot :close="close" />
      </div>
    </responsive-modal>
  </div>
</template>
<script>
export default {
  props: {
    buttonClass: String,
    label: String,
    description: Boolean
  },
  data() {
    return {
      modal: false
    };
  },
  methods: {
    close() {
      this.modal = false;
    }
  }
};
</script>
<style lang="scss" scoped>
i {
  font-size: 14px;
}
</style>
